import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HomeSection, Loading, SliderItem } from "../domain";
import {
  HomeContent,
  HomeRepository,
} from "../domain/repositories/home-repository";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type HomeState = {
  loading: Loading;
  slider: SliderItem[];
  sections: HomeSection[];
};

const initialState: HomeState = {
  loading: "idle",
  sections: [],
  slider: [],
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    homeLoading(state) {
      state.loading = "pending";
    },
    homeSuccess(state, { payload }: PayloadAction<HomeContent>) {
      state.slider = payload.slider;
      state.sections = payload.sections;
      state.loading = "succeeded";
    },
    homeFailure(state) {
      state.loading = "failed";
    },
  },
});

export default homeSlice.reducer;

const { homeFailure, homeLoading, homeSuccess } = homeSlice.actions;

export const loadHome = (): AppThunk => async (dispatch) => {
  dispatch(homeLoading());
  const res = await ServiceLocater.get<HomeRepository>(
    Services.HomeRepository
  ).getHomeContent();
  res.fold(
    (_) => {
      dispatch(homeFailure());
    },
    (r) => {
      dispatch(homeSuccess(r));
    }
  );
};
